import React from 'react';
import './ViewerHeader.css';
import UploadFile from './UploadFile';
import TakePhoto from './TakePhoto';

export default function ViewerHeader() {

  return (
    <div className="dbr-viewer-header">
      <UploadFile />
      <TakePhoto />
      <a className="dbr-toJsDemo" target="_blank" rel="noreferrer" href="https://demo.dynamsoft.com/barcode-reader-js/?source=dbrdemo">
        Video Scanning {'>'}
        <div className='dbr-toJsDemo-box'>Redirect to <strong>JavaScript online demo</strong> to perform barcode scanning on the client side via <strong>web browser</strong>.</div>
      </a>
    </div>
  );
}